export const applicationDataPrivacyStatement =
  'https://feather.jobs.personio.com/privacy-policy?language=en';
export const FEATHER_TALLY_BASE = 'https://forms.feather-insurance.com/';
